// ** React Imports
import React, { SyntheticEvent, forwardRef, MouseEvent, useRef, useState, useEffect, ChangeEvent } from 'react';
// import { CSVLink, CSVDownload } from "react-csv"

// ** MUI Imports
import Wrapper from '../../../components/Wrapper';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import AddIcon from '@mui/icons-material/Add';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

// ** Third Party Imports

// ** Icons Imports

// ** Third Party Styles Imports
import 'react-datepicker/dist/react-datepicker.css'
import Box from '@mui/material/Box';

import Title from '../../../components/Title';
import axios from "axios";
import { Office } from '../../../models/office';
import { Collect } from '../../../models/collect';
import { NavLink, useParams } from 'react-router-dom';
import { log } from 'console';
import HeaderResponsive from '../../../components/layouts/HeaderResponsive';
import PermissionButton from '../../../components/common/PermissionButton';
import { useResourcePermissions } from '../../../hooks/useResourcePermissions';

// const [office_id, setOffice_id] = useState('');
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#9d9d9d',
      color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
  },
  // hide last bor        der
  '&:last-child td, &:last-child th': {
      border: 0,
  },
}));

const ExportarClientes = () => {
  const { canExport } = useResourcePermissions('/procesos/exportarclientes');

  // const navigate = useNavigate();
  const [name, setName] = useState('');
  const [user_id, setUser_id] = useState('');
  const [user_first_name, setUser_first_name] = useState('');
  const [user_lastname, setUser_last_name] = useState('');
  const [ingress_date, setIngress_date] = useState('')
  const [office_id, setOffice_id] = useState('');
  const [office_name, setOffice_name] = useState('');
  const [selectedOfficeId, setSelectedOfficeId] = useState('');
  // const [ingress_date, setIngress_date] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const { id } = useParams();
  const [constants, setConstants] = useState<Collect[]>([]);
  const [selectedConstants, setSelectedConstants] = useState<number[]>([]);
  const [collect_id, setCollect_id] = useState("");
  
  const [offices, setOffices] = useState([]);
  useEffect(() => {
    (
      async () => {
        const { data } = await axios.get('offices');
        setOffices(data.data);
      }
    )();
  }, []);

    const [collects, setCollection] = useState([]);
    useEffect(() => {
        (
            async () => {
                const { data } = await axios.get('collects');
                setCollection(data.data);
            }
        )();
    }, []);

    const [collectsOffice, setCollectsOffice] = useState([]);
    useEffect(() => {
      if (office_id) {
          (
              async () => {
                  try {
                      const { data } = await axios.get(`collectsoffice/${office_id}`);
                      setCollectsOffice(data)
                  } catch (error) {
                      console.error("Error fetching data:", error);
                  }
              }
          )();
      }
  }, [office_id]);

  const [collectClient, setCollectClient] = useState([]);
  const [cedula, setCedula] = useState('');
  const [nombre, setNombre] = useState('');
  const [tel, setTel] = useState('');
  const [direccion, setDireccion] = useState('');
  const [valor, setValor] = useState('');
  const [fecha, setFecha] = useState('');
  const [saldo, setSaldo] = useState('');


  useEffect(() => {
    if (collect_id) {
      (async () => {
        try {
          const { data } = await axios.get(`collectclient/${collect_id}`);
          setCollectClient(data.data);
          setCedula(data.data.idnumber)
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      })();
    }

  }, [collect_id]);

const handleExport = async () => {
  if (!canExport) {
    return;
  }
  const formData = {
    collect_id
  };

  try {
    const response = await axios.post('/report/exportarclientes', formData, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'clientes.csv';
    document.body.appendChild(link); // Append the link to the document body
    link.click();
    document.body.removeChild(link); // Remove the link from the document body after clicking
  } catch (error) {
    // Handle error if needed
    console.error('Export error:', error);
  }
};

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <HeaderResponsive>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Title>Exportar Clientes</Title>
        <PermissionButton
          allowed={canExport}
          deniedTooltip="Sin permiso para exportar"
          tooltip="Exportar"
          variant="contained"
          onClick={handleExport}
          startIcon={isMobile ? null : <AddIcon />}
        >
          {isMobile ? <AddIcon /> : "Exportar"}
        </PermissionButton>
        {/* <Button variant="contained" startIcon={isMobile ? <AddIcon /> : 'Exportar'}>
          {isMobile ? (
          ) : null }
        </Button> */}
        {/* <CSVLink data={collectClient}>Exportar</CSVLink> */}
      </Box>
      <Card>
        {/* <CardHeader title='Multi Column with Form Separator' titleTypographyProps={{ variant: 'h6' }} /> */}
        <Divider sx={{ margin: 0 }} />
        <form onSubmit={(e) => e.preventDefault()}>
          <CardContent>
             <Grid container spacing={2}>
              {/* <Grid item xs={12}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  Exportar clientes
                </Typography>
              </Grid> */}

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="form-layouts-separator-select-label">
                  Seleccionar Oficina
                  </InputLabel>
                  {offices && offices.length > 0 ? (
                    <Select
                      label="Seleccionar Oficina"
                      //   defaultValue=''
                      value={office_id}
                      // onChange={handleSelectChange}
                      id="form-layouts-separator-select"
                      labelId="form-layouts-separator-select-label"
                      onChange={(event) => setOffice_id(event.target.value)}
                      required
                    >
                      {offices.map((office: Office) => {
                        return (
                          <MenuItem key={office.id} value={office.id}>
                            {office.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="collect">Seleccionar Cobro</InputLabel>
                  {collectsOffice && collectsOffice.length > 0 ? (
                    <Select
                      label="Seleccionar Cobro"
                      value={collect_id} // Use the state variable here
                      id="collects_id"
                      labelId="collects_id"
                      onChange={(event) => setCollect_id(event.target.value)}
                      required
                    >
                      {collectsOffice.map((collect: Collect) => (
                        <MenuItem key={collect.id} value={collect.id}>
                          {collect.name}
                        </MenuItem>
                      ))}
                    </Select>
                  ) : null}
                </FormControl>
              </Grid>
              {/* boton: */}
      {/* <div className="pt-3 pb-2 mb-3 border-bottom">
            <a href="#" className="btn btn-sm btn-outline-secondary" onClick={handleExport}>Export</a>
        </div> */}
            </Grid>
          </CardContent>
          <Divider sx={{ margin: 0 }} />
        </form>
      </Card>
    </HeaderResponsive>
  );
}

export default ExportarClientes
